import { AxiosRequestConfig } from 'axios'

export function removeEmptyParams(config: AxiosRequestConfig<unknown>): void {
    const parameters = config.params

    Object.entries(parameters).forEach(([key, value]) => {
        if (value === '') {
            delete parameters[key]
        }
    })
}
